import { useAuth } from "../store/useAuth";
import { accessDebug, accessDebugWarn } from "./accessDebug";
import { setEventSlugGetter } from "../lib/axios";

const EVENT_CONTEXT_KEYS = new Set(["eventId", "roleId", "eventSlug"]);

setEventSlugGetter(() => {
  try {
    return useAuth.getState()?.eventSlug || null;
  } catch {
    return null;
  }
});

export const setDashboardContext = (partial = {}) => {
  const before = useAuth.getState();
  accessDebug("DashboardContext", "set requested", {
    partial,
    before: {
      eventId: before.eventId,
      roleId: before.roleId,
      eventSlug: before.eventSlug,
    },
  });
  useAuth.getState().setEventContext(partial);
  const after = useAuth.getState();
  accessDebug("DashboardContext", "set completed", {
    after: {
      eventId: after.eventId,
      roleId: after.roleId,
      eventSlug: after.eventSlug,
    },
  });
};

export const getDashboardContextValue = (key) => {
  if (!EVENT_CONTEXT_KEYS.has(key)) {
    accessDebugWarn("DashboardContext", "unknown key requested", { key });
    return null;
  }
  const value = useAuth.getState()[key];
  return value === undefined ? null : value;
};

export const clearDashboardContext = () => {
  accessDebug("DashboardContext", "clearing event context", {
    eventId: useAuth.getState().eventId,
    roleId: useAuth.getState().roleId,
    eventSlug: useAuth.getState().eventSlug,
  });
  useAuth.getState().clearEventContext();
};

// Dashboard context (eventId/roleId/eventSlug) now lives in the useAuth store,
// not localStorage. Bridge kept as a no-op so existing callers don't break.
export const installDashboardContextStorageBridge = () => {};
